import React, { useEffect } from 'react';
import Lottie from 'lottie-react';
import animSad from '../assets/anim/anim-sad.json';

export default function Page404() {

    const handleClick = () => {
        window.location.replace('https://app.pilot.dexcart.in');
    }

    useEffect(() => {
        handleClick();
    }, [])

    return (
        <div className="min-h-screen w-screen flex items-center justify-center bg-white px-4">
            <div className="flex flex-col items-center justify-center text-center w-full">
                <Lottie animationData={animSad} className="w-40 mb-10" loop />
                <h2 className="text-red-600 text-8xl md:text-9xl font-bold">404</h2>
                <p className="text-gray-700 text-base md:text-lg font-normal mt-4">
                    The page you are attempting to reach is currently not available.
                    <br />
                    This may be because the page does not exist or has been moved.
                </p>
                <div onClick={() => { handleClick(); }} className="text-white bg-red-500 hover:bg-red-600 rounded-md w-60 md:w-80 py-2 mt-10 transition-all cursor-pointer">
                    BACK TO HOME PAGE
                </div>
            </div>
        </div>
    )
}
